
































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EchartOption from '@/common/const/e-chart-options';
import CustomTab from './custom-tab/index.vue';
import { commaNumber } from '../format';
import * as api from '@/api/business-overview';
@Component({
  components: { CustomTab }
})
export default class PaymentStatistics extends Vue {
  commaNumber: Function = commaNumber;

  @Prop({ default: 0 })
  type?: number;

  @Prop({ default: () => [] })
  orgIds: any[];

  @Prop()
  parkId?: String;

  timeTypeTabs: any[] = [
    {
      label: '昨日',
      value: 'yesterday'
    },
    {
      label: '本周',
      value: 'week'
    },
    {
      label: '本月',
      value: 'month'
    }
  ];

  timeType: number = 0;
  sourceType: string = 'allSource';
  data: any = {};

  @Watch('orgIds')
  @Watch('parkId')
  @Watch('timeType')
  needRefresh() {
    this.init();
  }

  @Watch('sourceType')
  onSourceTypeChange() {
    let seriesData = [];
    if (this.data[this.sourceType]) {
      seriesData = this.data[this.sourceType].data.map((i: { methodName: any; amount: any }) => {
        return {
          name: i.methodName,
          value: i.amount
        };
      });
      this.total = this.data[this.sourceType].total;
    }
    this.seriesData = seriesData;
    this.refreshChart();
  }

  options: EchartOption = new EchartOption();
  isData: boolean = true;
  seriesData: any[] = [];
  total: number = 0;

  get title() {
    return this.seriesData.length
      ? {
          show: false
        }
      : {
          text: '暂无数据',
          top: 'center',
          left: 'center',
          textStyle: {
            fontSize: 16
          }
        };
  }

  get toolTip() {
    return {
      show: true,
      trigger: 'item'
      // formatter: '{a} <br/>{b} : {c}%',
    };
  }

  get grid() {
    return {
      top: '8%',
      left: '5%',
      right: '5%',
      bottom: '5%',
      containLabel: true
    };
  }

  get legend() {
    return {
      show: false
    };
  }

  get xAxis() {
    return {
      show: false
    };
  }

  get yAxis() {
    return [
      {
        type: 'value',
        axisLabel: {
          show: true
        },
        splitLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }
      }
    ];
  }

  get series() {
    return [
      {
        name: '缴费方式',
        type: 'pie',
        radius: ['50%', '70%'],
        data: this.seriesData,
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        },
        label: {
          position: 'center',
          formatter: `{title|收入总额}\n{value|¥ ${commaNumber(this.total)}}`,
          rich: {
            title: {
              color: '#999',
              fontSize: 18,
              padding: [20, 0, 0, 0]
            },
            value: {
              color: '#000',
              fontSize: 25
            }
          }
        }
      }
    ];
  }

  async fetchChartData() {
    const timeTypeValue = this.timeTypeTabs[this.timeType].value;
    let param;
    if (this.type == 0) {
      param = {
        type: timeTypeValue,
        orgIds: this.orgIds
      };
    } else {
      param = {
        type: timeTypeValue,
        parkId: this.parkId
      };
    }
    try {
      const { data } = await api.queryPaymentStatistics(param);
      this.data = data;
      let seriesData = [];
      if (data[this.sourceType]) {
        seriesData = this.data[this.sourceType].data.map((i: { methodName: any; amount: any }) => {
          return {
            name: i.methodName,
            value: i.amount
          };
        });
        this.total = data[this.sourceType].total;
      }
      this.seriesData = seriesData;
    } catch (e) {
      console.log(e);
    } finally {
      this.refreshChart();
    }
  }

  get colors() {
    // 支付宝、微信、现金、ETC、储值卡的依次为：#33A6FF，#50CE96，#FF7A8A，#F2B256，#C084DC
    //return ['#3aa0ff', '#36cbcb', '#4dcb73', '#fad337', '#f2637b', '#975fe4']
    return ['#FF7A8A', '#50CE96', '#33A6FF', '#fad337', '#f2637b', '#C084DC', '#F2B256'];
    //现金 微信 支付宝 优惠券 积分 储值卡
  }

  refreshChart() {
    const options: EchartOption = new EchartOption();
    options.setColor(this.colors);
    options.setLegend(this.legend);
    options.setGrid(this.grid);
    options.setXAxis(this.xAxis, true);
    options.setYAxis(this.yAxis, true);
    options.setTitle(this.title);
    options.setSeries(this.series);
    options.setTooltip(this.toolTip);
    this.options = options;
  }

  init() {
    this.fetchChartData();
  }

  mounted() {
    this.init();
  }
}
